import styled from 'styled-components';

export const VehicleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 36px;

  tr th {
    color: ${({ theme }) => theme.colors.gray[600]};
    font-size: clamp(12px, 1vw, 16px);
    font-weight: 600;
    flex: 1 !important;
    min-width: 88px;

    &.driverName {
      width: 20%;
    }
  }
  tr td {
    color: ${({ theme }) => theme.colors.gray[500]};
    font-size: clamp(12px, 1vw, 16px);
    font-weight: 500;

    &.driverName {
      display: -webkit-box; 
      max-height: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin: 0 auto;
      max-width: none;
      width: 90%;

      p {
        max-width: 330px;
        margin: 0 auto;
      }
    }
  }
  tr td:first-child {
    > div {
      margin: 0 auto;
      display: flex;
      align-items: center;
      gap: 8px;
      width: 124px;
    }
  }

  .infiniteScroll {
    padding: 0 2px 10px 2px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: relative;
  min-width: fit-content;

  div:first-child {
    position: relative;

    &:hover:before {
      /*Triangulo*/
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      /*Faz seta "apontar para baixo. Definir o valor como 'top' fará ela "apontar para cima" */
      /*Aqui entra a cor da "aba" do balão */
      border-top: 10px solid #fff;
      z-index: 112;
      top: -8px;
      left: 0px;
    }

    &:hover:after {
      content: 'Ver detalhes';
      position: absolute;
      color: ${({ theme }) => theme.colors.gray[900]};
      font-size: 12px;
      text-transform: initial;

      height: fit-content;
      width: fit-content;
      white-space: nowrap;

      padding: 0px 24px;
      z-index: 111;

      border-radius: 8px;

      top: -26px;
      left: -52px;

      box-shadow: 0px 4px 16px ${({ theme }) => theme.colors.gray[400]};
      background-color: ${({ theme }) => theme.colors.background.white};
    }
  }

  div {
    cursor: pointer;
    max-width: fit-content;
    height: fit-content;
    padding: 0px 0px;

    :hover {
      color: ${({ theme }) => theme.colors.orange.primary};
    }

    svg {
      color: ${({ theme }) => theme.colors.gray[500]};
      width: clamp(14px, 1.5vw, 24px);
      height: clamp(14px, 1.5vw, 24px);
    }
  }
`;

export const ButtonsContainer = styled.div``;

export const ImportingProgress = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  span {
    width: fit-content;
    justify-self: end;
  }
`;

export const ConsultsPackageInProgress = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  justify-content: center;
  gap: 12px;
  align-items: center;
  font-size: 12px;
  span {
    width: fit-content;
    justify-self: end;
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  height: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr 1fr; 
  }

  > div,
  > label {
    flex: 1;
    min-width: 288px;
  }
  div button {
    width: 100%;
  }

  .importVehicles {
    display: grid;
    gap: 10px;
  }

  .inputSearch {
    position: relative;

    div {
      width: 100%;
    }

    input {
      width: 100%;
      padding-left: 44px;
      font-weight: 300;
      font-size: 14px;
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      border-radius: 12px;
      left: 0px;
      top: 0px;
      height: 48px;
      width: 40px;

      &:active {
        transform: translate(1px, 1px);
      }
      svg {
        color: ${({ theme }) => theme.colors.orange.primary};
        height: 20px;
        width: 20px;
      }
    }
  }
`;

export const CheckBoxInput = styled.input`
  margin-right: 12px;
  width: 16px;
  height: 16px;
  border: none;
  text-decoration: none;
  outline: none;
`;
